import api from './api';

class TokenDistributionApi {
  // Distribute tokens from source to multiple destinations
  async distributeTokens(tokenAddress, sourceWallet, targetWallets, totalAmount, variance = 0, customAmounts = {}) {
    try {
      const response = await api.post('/token-distribution/distribute', {
        token_address: tokenAddress,
        source_wallet: sourceWallet,
        target_wallets: targetWallets,
        total_amount: totalAmount,
        variance: variance,
        custom_amount: customAmounts
      });

      return response.data;
    } catch (error) {
      console.error('Token distribution error:', error);
      throw error;
    }
  }

  // Gather tokens from multiple sources to a single destination
  async gatherTokens(tokenAddress, sourceWallets, targetWallet, totalAmount, customAmounts = {}) {
    try {
      const response = await api.post('/token-distribution/gather', {
        token_address: tokenAddress,
        source_wallets: sourceWallets,
        target_wallet: targetWallet,
        total_amount: totalAmount,
        custom_amount: customAmounts
      });

      return response.data;
    } catch (error) {
      console.error('Token gather error:', error);
      throw error;
    }
  }

  // Get token balance for a wallet
  async getTokenBalance(walletAddress, tokenAddress) {
    try {
      const response = await api.post('/wallet/token-balance', {
        walletAddress,
        tokenAddress
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching token balance:', error);
      throw error;
    }
  }

  // Get multiple token balances for multiple wallets
  async getMultipleTokenBalances(walletAddresses, tokenAddress) {
    try {
      const response = await api.post('/wallet/multiple-token-balances', {
        walletAddresses,
        tokenAddress
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching multiple token balances:', error);
      throw error;
    }
  }
}

export default new TokenDistributionApi();